import Menu from 'antd/es/menu';
import styled from 'styled-components';
import { TMenuItemProps, TMenuProps } from './Menu.type';

const { Item } = Menu;
const SMenu = styled(Menu)<TMenuProps>``;

const SMenuItem = styled(Item)<TMenuItemProps>``;
export { SMenu, SMenuItem };
